import { legacyBridge } from '@/services/legacyBridge'
import { tabMetrics } from '@/ContextTab/services/tabMetrics'
import { GatewaySubType } from '@/Workers/Gateway/gwService/constants'
import { useAuthStore, AuthStatus } from '@/ContextTab/stores/auth/auth'
import { useShareNewsModalStore } from '@/ContextTab/stores/shareNews'
import { useUserProfileStore } from '@/ContextTab/stores/userProfile'
import { useGatewayStore } from '@/ContextTab/stores/gateway'


export function useLegacyBridge() {

  const authStore = useAuthStore()
  const userProfileStore = useUserProfileStore()
  const shareNewsModalStore = useShareNewsModalStore()
  const gatewayStore = useGatewayStore()

  legacyBridge.onMessage(async (message) => {

    // Checking window.contextId to handle messages once at original tab.
    // Some actions require all tabs to handle messages.

    switch (message.data.action) {
      case 'oldLogout':
        if (authStore.status === AuthStatus.authorized) {
          authStore.logout()
        }
        break

      case 'gatewaySubscribe':
        if (
          message.data.contextId
          && message.data.contextId === window.contextId
        ) {
          if (message.data.payload.type === GatewaySubType.FLOW_LEADS) {
            gatewayStore.subscribe(
              GatewaySubType.FLOW_LEADS,
              { flow_id: message.data.payload.id },
            )
          } else if (message.data.payload.type === GatewaySubType.SPECIFIC_NEWS) {
            gatewayStore.subscribe(
              GatewaySubType.SPECIFIC_NEWS,
              { news_id: message.data.payload.id },
            )
          }
        }
        break

      case 'gatewayUnsubscribe':
        if (
          message.data.contextId
          && message.data.contextId === window.contextId
        ) {
          if (message.data.payload.type === GatewaySubType.FLOW_LEADS) {
            gatewayStore.unsubscribe(
              GatewaySubType.FLOW_LEADS,
              { flow_id: message.data.payload.id },
            )
          } else if (message.data.payload.type === GatewaySubType.SPECIFIC_NEWS) {
            gatewayStore.unsubscribe(
              GatewaySubType.SPECIFIC_NEWS,
              { news_id: message.data.payload.id },
            )
          }
        }
        break

      case 'updateProfile':
        await userProfileStore.updateProfile(message.data.profile)
        break

      case 'showShareModal':
        if (
          message.data.contextId
          && message.data.contextId === window.contextId
        ) {
          shareNewsModalStore.showShareModal(
            {
              itemId: message.data.payload.itemId,
              actionType: message.data.payload.actionType,
              hasKeepOriginal: message.data.payload.params?.hasKeepOriginal ?? true,
            },
            'publishing-ui',
          )
        }
        break

      case 'sentry': {
        if (
          message.data.contextId
          && message.data.contextId === window.contextId
        ) {
          if (message.data.content.type === 'error') {
            tabMetrics.sendException(
              'Legacy error: ' + message.data.content.message,
              message.data.content.extra,
            )
          } else if (message.data.content.type === 'message') {
            tabMetrics.sendMessage('Legacy message: ' + message.data.content.message)
          }
        }
      }
    }
  })
}
